import React from 'react';
import SlideThumbnail from './SlideThumbnail';

function SlideThumbnailRow(props) {

    console.log("desktopMode = " + props.desktopMode);

    function manageThumbnails() {
        if (props.images == null) {
          return null;
        }
        return props.images.map((img, i) => (
          // Without the `key`, React will fire a key warning
          <SlideThumbnail
            key={"imth_" + i}
            fileName={props.urlBase + img.DSNomeFile}
            title={img.DSMetaTitle_It}
            alt={img.DSMetaDescrizione_It}
            idx={i}
            active={props.currentIdx === i ? true : false}
            clickHandler={props.clickHandler}
          />
        ));    
    }  
    
    return (
      <div className="contenitore-thumbnails">
        <div className="AW-freccia-thumb-sx" onClick={props.prevSlide}>
          &nbsp;
          <img src={"/images/Arrow_up.svg"}  alt="verso sinistra"/>
        </div>

        <div className="slide_thumbnails">
          <div className="slide_04">{manageThumbnails()}</div>
        </div>
        <div className="AW-freccia-thumb-dx " onClick={props.nextSlide}>
          &nbsp;
          <img src={"/images/Arrow_down.svg"}  alt="verso destra"/>
        </div>
      </div>
    );

}

export default SlideThumbnailRow;